var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.tweetsListContainer,attrs:{"data-luko-tracking":"TweetsList"}},_vm._l((_vm.items),function(item,itemIndex){return _c('TwitterTestimonial',{key:itemIndex,class:_vm.$style.tweet,attrs:{"content":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }